"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStarRating = exports.getSlug = exports.getQualificationsBullets = exports.getProsBullets = exports.getLoanTermMax = exports.getLegacyId = exports.getLearnMoreLinkTitle = exports.getLearnMoreLink = exports.getIssuerName = exports.getImageSrc = exports.getImageAltText = exports.getFicoMin = exports.getConsBullets = exports.getCollateral = exports.getBottomLine = exports.getAprTooltip = exports.getAprMin = exports.getAprMax = exports.getAprAverage = exports.getName = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _generalUtils = require("./common/general-utils");

var _utils = require("../utils");

/**
 * Get the name of the marketplace entity. There are currently no fallbacks.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {string}                    The name
 */
var getName = function getName(marketplaceEntity) {
  return (0, _utils.getNameWithFallbacks)(marketplaceEntity);
};
/**
 * Get the average APR %.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {number}                    The average APR
 */


exports.getName = getName;

var getAprAverage = function getAprAverage(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.apr_average.value');
};
/**
 * Get the max APR %.
 *
 * @param     {Object} marketplaceEntity  The smb loans entity
 * @return    {number}                    The max APR
 */


exports.getAprAverage = getAprAverage;

var getAprMax = function getAprMax(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.max_apr.value');
};
/**
 * Get the min APR %.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {number}                    The min APR
 */


exports.getAprMax = getAprMax;

var getAprMin = function getAprMin(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.min_apr.value');
};
/**
 * Get the APR tooltip.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {string}                    The APR tooltip
 */


exports.getAprMin = getAprMin;

var getAprTooltip = function getAprTooltip(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.apr_tooltip.value');
};
/**
 * Get the bottom line text.
 *
 * @param  {Object} marketplaceEntity   The marketplace entity
 * @return {String}                     The bottom line value.
 */


exports.getAprTooltip = getAprTooltip;

var getBottomLine = function getBottomLine(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.tagline.value');
};
/**
 * Gets whether this smb loans entity requires collateral.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {bool}                      collateral
 */


exports.getBottomLine = getBottomLine;

var getCollateral = function getCollateral(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.collateral.value');
};
/**
 * Gets the "cons" bullets
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {Array}                     The "cons" array
 */


exports.getCollateral = getCollateral;

var getConsBullets = function getConsBullets(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.cons_bullets.value');
};
/**
 * Get the minimum recommended FICO score.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {string}                    The min FICO score
 */


exports.getConsBullets = getConsBullets;

var getFicoMin = function getFicoMin(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.min_fico_displayed.value');
};
/**
 * Gets the name of the entity as the alt text for the associated image
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {string}                    Alt text
 */


exports.getFicoMin = getFicoMin;

var getImageAltText = function getImageAltText(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.image_alt_text.value') || getName(marketplaceEntity);
};
/**
 * Get the source URL of the image associated with the marketplace entity.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {string}                    The URL of the image
 */


exports.getImageAltText = getImageAltText;

var getImageSrc = function getImageSrc(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.image_source.value');
};
/**
 * Get the issuer
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {string}                    Issuer name
 */


exports.getImageSrc = getImageSrc;

var getIssuerName = function getIssuerName(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'name');
};
/**
 * Get the learn more link.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {string}                    Learn more link
 */


exports.getIssuerName = getIssuerName;

var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.review_link.value');
};
/**
 * Get the learn more link title.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {string}                    Learn more link title
 */


exports.getLearnMoreLink = getLearnMoreLink;

var getLearnMoreLinkTitle = function getLearnMoreLinkTitle(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.review_title.value');
};
/**
 * Get the legacy id for an entity.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {string}                    The legacy id
 */


exports.getLearnMoreLinkTitle = getLearnMoreLinkTitle;

var getLegacyId = function getLegacyId(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.legacy_id.value');
};
/**
 * Get the maximum loan term in months.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {number}                    The maximum loan term in months
 */


exports.getLegacyId = getLegacyId;

var getLoanTermMax = function getLoanTermMax(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.max_loan_term.value');
};
/**
 * Gets the "pros" bullets
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {Array}                     The "pros" array
 */


exports.getLoanTermMax = getLoanTermMax;

var getProsBullets = function getProsBullets(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.pros_bullets.value');
};
/**
 * Get the qualifications bullets.
 *
 * @param   {Object} marketplaceEntity  The smb loans entity
 * @return  {Array}                     The qualifications bullets
 */


exports.getProsBullets = getProsBullets;

var getQualificationsBullets = function getQualificationsBullets(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.qualifications_bullets.value');
};
/**
 * Get the slug.
 * @todo this field is not yet populated
 *
 * @param   {Object} marketplaceEntity  The marketplace entity
 * @return  {String}                    The slug
 */


exports.getQualificationsBullets = getQualificationsBullets;

var getSlug = function getSlug(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'external_id');
};
/**
 * Get the star rating.
 *
 * @param   {Object} marketplaceEntity  The education loans entity
 * @return  {number}                    The star rating
 */


exports.getSlug = getSlug;

var getStarRating = function getStarRating(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.rating_stars.value');
};

exports.getStarRating = getStarRating;